/**
 * gammaInfluenceFlags.ts — MER Algo Footprints v7.1B — Phase 6.3B
 *
 * Feature flags for Gamma confidence and ranking influence.
 * Phase 6.3A: confidence-only. Phase 6.3B: adds explicit ranking influence.
 * Both paths are independently gated and default OFF.
 */

export interface GammaInfluenceFlags {
  gammaScoringEnabled:          boolean;
  gammaAllowStaleInfluence:     boolean;
  gammaMaxConfidenceAdjustment: number;
  gammaRankingEnabled:          boolean;
  gammaRankingWeight:           number;
  gammaRankingWeightMax:        number;
  gammaMaxRankingAdjustment:    number;
  gammaAuditLoggingEnabled:     boolean;
}

export const GAMMA_INFLUENCE_FLAGS: GammaInfluenceFlags = {
  gammaScoringEnabled:          false,
  gammaAllowStaleInfluence:     false,
  gammaMaxConfidenceAdjustment: 8,
  gammaRankingEnabled:          false,
  gammaRankingWeight:           0.03,
  gammaRankingWeightMax:        0.05,
  gammaMaxRankingAdjustment:    5,
  gammaAuditLoggingEnabled:     true,
};

export const GAMMA_STALE_MAGNITUDE     = 0.5;
export const GAMMA_MIN_SCORE_THRESHOLD = 55;
export const GAMMA_MIN_DATA_QUALITY: 'high' | 'medium' | 'low' = 'medium';
